<template>
  <div v-if="isCategory" class="tree-node">

    <!-- MAIN CATEGORY -->
    <div v-if="level === 0" class="card mb-2 main-category">
      <div class="card-header d-flex align-items-center gap-2 main-category-header text-uppercase">
        <font-awesome-icon
          :icon="faClipboardList"
          class="mr-2 force-white-all"
        />
        {{ item.item_to_be_checked }}
      </div>

      <div class="card-body tree-children root main-category-body">

        <!-- ✅ ROOT ITEMS -->
        <div v-if="itemChildren.length" class="category-group">
          <div class="items-container">
            <table class="table table-sm table-bordered mb-0">
              <thead>
              <tr>
                <th style="width: 40px;"></th>
                <th>ITEMS TO BE CHECKED</th>

                <!-- BOOLEAN -->
                <th v-if="hasBooleanItems" style="width: 120px;">CHECK</th>

                <!-- SCORE -->
                <th v-if="hasScoreItems" style="width: 90px;">MAX PT</th>
                <th v-if="hasScoreItems" style="width: 90px;">NOW</th>

                <th v-if="hasBooleanItems && $route.params.type === 'sms'" style="width: 120px;">NCR TYPE</th>
                <th v-if="$route.params.type === 'sms'" style="width: 150px;">NCR DESCRIPTION</th>
                <th v-if="$route.params.type === 'sms'" style="width: 80px;">REF</th>
                <th v-if="$route.params.type === 'sms'" style="width: 100px;">RISK LEVEL</th>
                <th v-if="$route.params.type === 'isps' || $route.params.type === 'cyber'" style="width: 150px;">REMARKS</th>
                <th style="width: 100px;" v-if="$route.params.type === 'isps'">ISPS</th>
                <th style="width: 100px;" v-if="$route.params.type === 'isps'">SSP</th>
                <th style="width: 100px;" v-if="$route.params.type === 'cyber'">CSP</th>

              </tr>
              </thead>

              <tbody>
              <tr
                v-for="child in itemChildren"
                :key="child.ia_type_checklist_id"
                :class="{
                    'table-success': child.is_ok === 1,
                    'table-danger': child.is_ok === 0,
                    'table-warning': child.has_error
                  }"
              >
                <td class="text-center">
                  <font-awesome-icon
                    :icon="child.is_ok === 1 ? faCheckCircle : faTimesCircle"
                    :class="child.is_ok ? 'force-success-all' : 'force-danger-all'"
                  />
                </td>

                <td>
                  <div class="d-flex align-items-center justify-content-between gap-2">

                    <div class="flex-grow-1">
                      <input
                        v-if="child.is_new || child.audit_type_id"
                        type="text"
                        class="form-control form-control-sm"
                        v-model="child.item_to_be_checked"
                        placeholder="Enter item"
                        style="font-size: 9pt;"
                      />

                      <span v-else>
                        {{ child.item_to_be_checked }}
                      </span>
                    </div>

                    <!-- DELETE BUTTON ONLY FOR OTHER ITEMS -->
                    <button
                      v-if="child.is_new || child.audit_type_id"
                      type="button"
                      class="btn btn-sm btn-link text-danger p-0 ml-2 force-danger-all"
                      @click="deleteOtherItem(child, item)"
                    >
                      <font-awesome-icon :icon="faTrash" />
                    </button>

                  </div>
                </td>

                <!-- BOOLEAN -->
                <td
                  v-if="child.answer_type === 'boolean'"
                  class="text-center answer-cell"
                >
                  <div v-if="isNotAnswerable(child)" class="answer-overlay"></div>
                  <button
                    class="button-status mr-1"
                    :class="child.is_ok === 0 ? 'button-status-not' : 'button-status-ok'"
                    :disabled="child.is_ok === 1 || isNotAnswerable(child)"
                    @click="updateItem(child, 'is_ok', 1)"
                  >
                    OK
                  </button>

                  <button
                    class="button-status"
                    :class="child.is_ok === 1 ? 'button-status-not' : 'button-status-x'"
                    :disabled="child.is_ok === 0 || isNotAnswerable(child)"
                    @click="updateItem(child, 'is_ok', 0)"
                  >
                    X
                  </button>

                </td>
                <!-- SCORE -->
                <td
                  v-if="child.answer_type === 'score'"
                  class="text-center answer-cell"
                >

                  <div v-if="isNotAnswerable(child)" class="answer-overlay">
                  </div>

                  <input
                    type="number"
                    min="1"
                    class="form-control form-control-sm"
                    v-model.number="child.max_pt"
                    style="font-size: 9pt;"
                    placeholder="Max"
                    :disabled="isNotAnswerable(child)"
                    @input="validateScore(child)"
                  />
                </td>
                <td
                  v-if="child.answer_type === 'score'"
                  class="text-center answer-cell"
                >

                  <div v-if="isNotAnswerable(child)" class="answer-overlay">
                  </div>

                  <input
                    type="number"
                    min="0"
                    :max="child.max_pt"
                    class="form-control form-control-sm"
                    :disabled="
                    !child.max_pt ||
                    child.max_pt <= 0 ||
                    isNotAnswerable(child)
                  "
                    v-model.number="child.pt_now"
                    style="font-size: 9pt;"
                    placeholder="Now"
                    @input="validateScore(child)"
                  />
                </td>

                <td v-if="child.answer_type === 'boolean' && $route.params.type === 'sms'" class="text-center answer-cell">
                  <div v-if="isNotAnswerable(child)" class="answer-overlay"></div>
                  <button
                    class="button-status mr-1"
                    :class="[
                    child.ncr_type === 'nc'
                      ? 'button-status-ncr-type'
                      : 'button-status-ncr-not',
                    { 'button-status-disabled': child.is_ok === 1 }
                  ]"
                    :disabled="child.is_ok === 1 || isNotAnswerable(child)"
                    @click="updateItem(child, 'ncr_type', 'nc')"
                  >
                    NC
                  </button>

                  <button
                    class="button-status"
                    :class="[
                    child.ncr_type === 'obs'
                      ? 'button-status-ncr-type'
                      : 'button-status-ncr-not',
                    { 'button-status-disabled': child.is_ok === 1 }
                  ]"
                    :disabled="child.is_ok === 1 || isNotAnswerable(child)"
                    @click="updateItem(child, 'ncr_type', 'obs')"
                  >
                    OBS
                  </button>
                </td>
                <td class="text-center">
                  <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" :disabled="child.is_ok === 1 && hasBooleanItems" v-model="child.ncr_type_description"></textarea>
                </td>
                <td class="text-center" v-if="$route.params.type === 'sms'">
<!--                  <input type="text" name="" id="" class="form-control form-control-sm" style="font-size: 9pt;" v-model="child.ref">-->
                  <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.ref"></textarea>
                </td>
                <td class="text-center" v-if="$route.params.type === 'sms'">
                  <select name="" id="" class="form-control form-control-sm" style="font-size: 9pt; font-weight: 700" :disabled="child.is_ok === 1 && hasBooleanItems" v-model="child.risk_level">
                    <option value="low">LOW</option>
                    <option value="med">MEDIUM</option>
                    <option value="high">HIGH</option>
                  </select>
                </td>
                <td class="text-center" v-if="$route.params.type === 'isps'">
                  <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.isps" :disabled="child.is_ok === 1 && hasBooleanItems"></textarea>
                </td>
                <td class="text-center" v-if="$route.params.type === 'isps'">
                  <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.ssp" :disabled="child.is_ok === 1 && hasBooleanItems"></textarea>
                </td>
                <td class="text-center" v-if="$route.params.type === 'cyber'">
                  <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.csp" :disabled="child.is_ok === 1 && hasBooleanItems"></textarea>
                </td>
              </tr>
              <tr>
                <td colspan="7">
                  <div class="divider-text">
                    <span
                      style="cursor: pointer"
                      class="badge badge-success p-1 pl-2 pr-2 text-white"
                      @click="addOtherItem(item)"
                    >
                      Add Others
                    </span>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- ✅ SUBCATEGORIES -->
        <ChecklistAnswerTree
          v-for="child in categoryChildren"
          :key="child.ia_type_checklist_id"
          :item="child"
          :level="level + 1"
        />

      </div>
      <div class="card-footer d-flex justify-content-between main-category-footer">
        <div class="summary-label">
          Total NCR Count:
          <span class="summary-value ncr-count">{{ computeMainCategoryStats(item).totalX }}</span>
<!--          <span class="summary-value ncr-count">{{ item?.ncr_count ?? 0 }}</span>-->
        </div>

        <div class="summary-label">
          Star Rating:
          <span class="summary-value ncr-count">
            {{ computeMainCategoryStats(item).avgRating.toFixed(2) }}
<!--            {{ item?.rating ?? 5 }}-->
          </span>
        </div>
      </div>
    </div>

    <!-- NESTED CATEGORY -->
    <div v-else class="tree-item" :class="{ 'no-connector': level === 1 }">

      <div class="category-group">

        <!-- Category label -->
        <div class="card category-card"
                  :style="{
            backgroundColor: formatColor(item.bg_color)
          }"
        >
          <div class="card-body p-2 d-flex justify-content-between align-items-center">
            <div>
              <font-awesome-icon :icon="faListUl" class="mr-2 ml-2" />
              <span :style="{ color: formatColor(item.font_color)}" class="text-uppercase">{{ item.item_to_be_checked }}</span>
            </div>

            <div class="rating-box" :style="{ color: formatColor(item.font_color)}">
              Rating:
<!--              <strong :style="{ color: formatColor(item.font_color)}">{{ item?.rating ?? 5 }}</strong>-->
              <strong :style="{ color: formatColor(item.font_color)}">{{ computeRating(item).rating.toFixed(2) }}</strong>
            </div>
          </div>
        </div>

        <!-- ✅ ITEMS -->
        <div v-if="itemChildren.length" class="items-container">
          <table class="table table-sm table-bordered mb-0 table-nested-sub">
            <thead>
            <tr>
              <th style="width: 40px;"></th>
              <th>ITEMS TO BE CHECKED</th>

              <!-- BOOLEAN -->
              <th v-if="hasBooleanItems" style="width: 120px;">CHECK</th>

              <!-- SCORE -->
              <th v-if="hasScoreItems" style="width: 90px;">MAX PT</th>
              <th v-if="hasScoreItems" style="width: 90px;">NOW</th>

              <th v-if="hasBooleanItems && $route.params.type === 'sms'" style="width: 120px;">NCR TYPE</th>
              <th v-if="$route.params.type === 'sms'" style="width: 150px;">NCR DESCRIPTION</th>
              <th v-if="$route.params.type === 'sms'" style="width: 80px;">REF</th>
              <th v-if="$route.params.type === 'sms'" style="width: 100px;">RISK LEVEL</th>
              <th v-if="$route.params.type === 'isps' || $route.params.type === 'cyber'" style="width: 150px;">REMARKS</th>
              <th style="width: 100px;" v-if="$route.params.type === 'isps'">ISPS</th>
              <th style="width: 100px;" v-if="$route.params.type === 'isps'">SSP</th>
              <th style="width: 100px;" v-if="$route.params.type === 'cyber'">CSP</th>
            </tr>
            </thead>

            <tbody>
            <tr
              v-for="child in itemChildren"
              :key="child.ia_type_checklist_id"
              :class="{
                  'table-warning': child.has_error,
                  'table-success': child.is_ok === 1,
                  'table-danger': child.is_ok === 0,

                }"
            >
              <td class="text-center">
                <font-awesome-icon
                  :icon="child.is_ok === 1 ? faCheckCircle : faTimesCircle"
                  :class="child.is_ok === 1 ? 'force-success-all' : 'force-danger-all'"
                />
              </td>

              <td>
                <div class="d-flex align-items-center justify-content-between gap-2">

                  <div class="flex-grow-1">
                    <input
                      v-if="child.is_new || child.audit_type_id"
                      type="text"
                      class="form-control form-control-sm"
                      v-model="child.item_to_be_checked"
                      placeholder="Enter item"
                      style="font-size: 9pt;"
                    />

                    <span v-else>
                        {{ child.item_to_be_checked }}
                      </span>
                  </div>

                  <!-- DELETE BUTTON ONLY FOR OTHER ITEMS -->
                  <button
                    v-if="child.is_new || child.audit_type_id"
                    type="button"
                    class="btn btn-sm btn-link text-danger p-0 ml-2 force-danger-all"
                    @click="deleteOtherItem(child, item)"
                  >
                    <font-awesome-icon :icon="faTrash" />
                  </button>

                </div>
              </td>

              <!-- BOOLEAN -->
              <td
                v-if="child.answer_type === 'boolean'"
                class="text-center answer-cell"
              >
                <div v-if="isNotAnswerable(child)" class="answer-overlay"></div>
                <button
                  class="button-status mr-1"
                  :class="child.is_ok === 0 ? 'button-status-not' : 'button-status-ok'"
                  :disabled="child.is_ok === 1 || isNotAnswerable(child)"
                  @click="updateItem(child, 'is_ok', 1)"
                >
                  OK
                </button>

                <button
                  class="button-status"
                  :class="child.is_ok === 1 ? 'button-status-not' : 'button-status-x'"
                  :disabled="child.is_ok === 0 || isNotAnswerable(child)"
                  @click="updateItem(child, 'is_ok', 0)"
                >
                  X
                </button>

              </td>
              <!-- SCORE -->
              <td
                v-if="child.answer_type === 'score'"
                class="text-center answer-cell"
              >

                <div v-if="isNotAnswerable(child)" class="answer-overlay">
                </div>

                <input
                  type="number"
                  min="1"
                  class="form-control form-control-sm"
                  v-model.number="child.max_pt"
                  style="font-size: 9pt;"
                  placeholder="Max"
                  :disabled="isNotAnswerable(child)"
                  @input="validateScore(child)"
                />
              </td>
              <td
                v-if="child.answer_type === 'score'"
                class="text-center answer-cell"
              >

                <div v-if="isNotAnswerable(child)" class="answer-overlay">
                </div>

                <input
                  type="number"
                  min="0"
                  :max="child.max_pt"
                  class="form-control form-control-sm"
                  :disabled="
                    !child.max_pt ||
                    child.max_pt <= 0 ||
                    isNotAnswerable(child)
                  "
                  v-model.number="child.pt_now"
                  style="font-size: 9pt;"
                  placeholder="Now"
                  @input="validateScore(child)"
                />
              </td>

              <td v-if="child.answer_type === 'boolean' && $route.params.type === 'sms'" class="text-center answer-cell">
                <div v-if="isNotAnswerable(child)" class="answer-overlay"></div>
                <button
                  class="button-status mr-1"
                  :class="[
                    child.ncr_type === 'nc'
                      ? 'button-status-ncr-type'
                      : 'button-status-ncr-not',
                    { 'button-status-disabled': child.is_ok === 1 }
                  ]"
                  :disabled="child.is_ok === 1 || isNotAnswerable(child)"
                  @click="updateItem(child, 'ncr_type', 'nc')"
                >
                  NC
                </button>

                <button
                  class="button-status"
                  :class="[
                    child.ncr_type === 'obs'
                      ? 'button-status-ncr-type'
                      : 'button-status-ncr-not',
                    { 'button-status-disabled': child.is_ok === 1 }
                  ]"
                  :disabled="child.is_ok === 1 || isNotAnswerable(child)"
                  @click="updateItem(child, 'ncr_type', 'obs')"
                >
                  OBS
                </button>
              </td>
              <td class="text-center">
                <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" :disabled="child.is_ok === 1 && hasBooleanItems" v-model="child.ncr_type_description"></textarea>
              </td>
              <td class="text-center" v-if="$route.params.type === 'sms'">
                <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.ref"></textarea>
              </td>
              <td class="text-center" v-if="$route.params.type === 'sms'">
                <select name="" id="" class="form-control form-control-sm" style="font-size: 9pt; font-weight: 700" :disabled="child.is_ok === 1 && hasBooleanItems" v-model="child.risk_level">
                  <option value="low">LOW</option>
                  <option value="med">MEDIUM</option>
                  <option value="high">HIGH</option>
                </select>
              </td>
              <td class="text-center" v-if="$route.params.type === 'isps'">
                <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.isps" :disabled="child.is_ok === 1 && hasBooleanItems"></textarea>
              </td>
              <td class="text-center" v-if="$route.params.type === 'isps'">
                <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.ssp" :disabled="child.is_ok === 1 && hasBooleanItems"></textarea>
              </td>
              <td class="text-center" v-if="$route.params.type === 'cyber'">
                <textarea class="form-control form-control-sm" style="font-size: 9pt;" rows="1" v-model="child.csp" :disabled="child.is_ok === 1 && hasBooleanItems"></textarea>
              </td>
            </tr>
            <tr>
              <td colspan="7">
                <div class="divider-text">
                  <span
                    style="cursor: pointer"
                    class="badge badge-success p-1 pl-2 pr-2 text-white"
                    @click="addOtherItem(item)"
                  >
                    Add Others
                  </span>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- SUBCATEGORIES -->
      <div class="tree-children">
        <ChecklistAnswerTree
          v-for="child in categoryChildren"
          :key="child.ia_type_checklist_id"
          :item="child"
          :level="level + 1"
        />
      </div>

    </div>

  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faClipboardList,
  faListUl,
  faCheckCircle,
  faTimesCircle,
  faTrash
} from "@fortawesome/free-solid-svg-icons";
import {InternalAuditChecklistService} from "@/services/InternalAuditChecklistService";
import Swal from "sweetalert2";

export default {
  name: "ChecklistAnswerTree",

  components: {
    FontAwesomeIcon
  },

  props: {
    item: Object,
    level: {
      type: Number,
      default: 0
    }
  },

  computed: {
    isCategory() {
      return this.item.is_category === 1;
    },

    categoryChildren() {
      return (this.item.sub_items || []).filter(
        child => child.is_category === 1
      );
    },

    itemChildren() {
      return (this.item.sub_items || []).filter(
        child => child.is_category === 0
      );
    },

    hasBooleanItems() {
      return this.itemChildren.some(i => i.answer_type === "boolean");
    },

    hasScoreItems() {
      return this.itemChildren.some(i => i.answer_type === "score");
    },

    faClipboardList() { return faClipboardList; },
    faListUl() { return faListUl; },
    faCheckCircle() { return faCheckCircle; },
    faTimesCircle() { return faTimesCircle; },
    faTrash() { return faTrash; }
  },

  methods: {
    formatColor(color) {
      if (!color) return '#000000'

      return color.startsWith('#')
        ? color
        : `#${color}`
    },

    isNotAnswerable(child) {
      return Number(child.answerable) === 0;
    },

    // ✅ UPDATE ITEM
    updateItem(child, field, value) {
      this.$set(child, field, value);

      // Clear NCR fields when OK
      if (field === "is_ok" && value === 1) {
        if (this.$route.params.type === 'sms') {
          child.ncr_type = null;
          child.ncr_type_description = null;
          child.ref = null;
          child.risk_level = null;
        }
        else if (this.$route.params.type === 'isps') {
          child.isps = null;
          child.ssp = null;
          child.ncr_type_description = null;
        }
        else if (this.$route.params.type === 'cyber') {
          child.csp = null;
          child.ncr_type_description = null;
        }
      }

      // If NCR selected → force X
      if (field === "ncr_type") {
        child.is_ok = 0;
      }

      this.$emit("update", {
        id: child.ia_type_checklist_id,
        field,
        value
      });
    },

    async deleteOtherItem(child, parentItem) {

      const confirm = await Swal.fire({
        title: 'Delete Other Item?',
        text: `Item: "${child.item_to_be_checked}"`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it',
        confirmButtonColor: '#20c997',
      })

      if (!confirm.isConfirmed) return

      try {

        // ✅ UNSAVED ITEM
        if (!child.ia_type_checklist_id) {

          parentItem.sub_items = parentItem.sub_items.filter(
            x => x !== child
          )

          return
        }

        // ✅ SAVED ITEM
        await InternalAuditChecklistService.deleteSubItem({
          deleted_item_to_be_checked_ids: [
            child.ia_type_checklist_id
          ]
        })

        // ✅ REMOVE LOCALLY
        parentItem.sub_items = parentItem.sub_items.filter(
          x => x.ia_type_checklist_id !== child.ia_type_checklist_id
        )

        // ✅ REFRESH
        this.$emit('refetch')

        Swal.fire({
          icon: 'success',
          title: 'Deleted',
          text: 'Other item removed successfully',
          timer: 1500,
          showConfirmButton: false,
          confirmButtonColor: '#20c997'
        })

      } catch (err) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to delete item'
        })
      }
    },

    validateScore(child) {

      // ✅ MAX PT MUST BE AT LEAST 1
      if (
        child.max_pt !== null &&
        child.max_pt !== '' &&
        Number(child.max_pt) < 1
      ) {
        child.max_pt = 1;
      }

      // ✅ PT NOW CANNOT BE NEGATIVE
      if (
        child.pt_now !== null &&
        Number(child.pt_now) < 0
      ) {
        child.pt_now = 0;
      }

      // ✅ RESET PT NOW IF MAX PT EMPTY
      if (
        child.max_pt === null ||
        child.max_pt === ''
      ) {
        child.pt_now = null;
        return;
      }

      // ✅ PT NOW CANNOT EXCEED MAX PT
      if (
        child.pt_now !== null &&
        Number(child.pt_now) >
        Number(child.max_pt)
      ) {
        child.pt_now = Number(child.max_pt);
      }
    },

    addOtherItem(parentItem) {

      // detect existing answer type
      const firstChild = (parentItem.sub_items || []).find(
        x => x.is_category === 0
      );

      const answerType = firstChild?.answer_type || "boolean";

      // create new item
      const newItem = {
        ia_type_checklist_id: null,

        parent_id: parentItem.ia_type_checklist_id,

        item_to_be_checked: "Other Item",

        is_category: 0,

        answer_type: answerType,

        // BOOLEAN
        is_ok: 1,
        ncr_type: null,

        // SCORE
        max_pt: null,
        pt_now: null,

        // COMMON
        ncr_type_description: null,
        ref: null,
        risk_level: null,

        // optional flags
        is_new: true,

        // ISPS
        isps: null,
        ssp: null,

        // CYBER
        csp: null,
      };

      // push into sub items
      parentItem.sub_items.push(newItem);
    },

    // ✅ SUBCATEGORY RATING (ONLY OWN ITEMS)
    // ✅ SUBCATEGORY RATING
    computeRating(item) {

      const notCategoryItems =
        (item.sub_items || []).filter(
          x => x.is_category === 0
        );

      const xCount =
        notCategoryItems.filter(
          x => x.is_ok === 0
        ).length;

      const hasScore =
        notCategoryItems.some(
          x => x.answer_type === 'score'
        );

      // SCORE TYPE
      if (hasScore) {

        const totalScore =
          notCategoryItems.reduce((sum, x) => {

            return sum + Number(x.pt_now || 0);

          }, 0);

        return {
          xCount: 0,

          rating:
            notCategoryItems.length
              ? totalScore / notCategoryItems.length
              : 5
        };
      }

      // BOOLEAN TYPE
      const totalCategory =
        notCategoryItems.length > 0
          ? 1
          : 0;

      const rating =
        totalCategory > 0
          ? (
            ((5 * totalCategory) - xCount)
            / totalCategory
          )
          : 5;

      return {
        xCount,
        rating: Math.max(0, rating)
      };
    },

// ✅ MAIN CATEGORY STATS
    computeMainCategoryStats(item) {

      const categoryItems =
        (item.sub_items || []).filter(
          x => x.is_category === 1
        );

      const notCategoryItems =
        (item.sub_items || []).filter(
          x => x.is_category === 0
        );

      const categoryCount =
        categoryItems.length;

      const notCategoryCount =
        notCategoryItems.length;

      const totalCategory =
        notCategoryCount > 0
          ? categoryCount + 1
          : categoryCount;

      // ROOT NCR
      const rootNcrCount =
        notCategoryItems.filter(
          x => x.is_ok === 0
        ).length;

      // CHILD NCR
      const childNcrCount =
        categoryItems.reduce((sum, cat) => {

          return (
            sum +
            this.computeMainCategoryStats(cat).totalX
          );

        }, 0);

      const totalX =
        rootNcrCount + childNcrCount;

      // SCORE TYPE
      const hasScore =
        notCategoryItems.some(
          x => x.answer_type === 'score'
        );

      if (hasScore) {

        const totalScore =
          notCategoryItems.reduce((sum, x) => {

            return sum + Number(x.pt_now || 0);

          }, 0);

        return {
          totalX: 0,

          avgRating:
            notCategoryItems.length
              ? totalScore / notCategoryItems.length
              : 5
        };
      }

      // BOOLEAN TYPE
      const rating =
        totalCategory > 0
          ? (
            ((5 * totalCategory) - totalX)
            / totalCategory
          )
          : 5;

      return {
        totalX,
        avgRating: Math.max(0, rating)
      };
    },

    // ✅ RECURSIVE X COUNT (FOR MAIN CATEGORY)
    computeDeepXCount(item) {
      let xCount = 0;

      const traverse = (node) => {
        if (node.is_category === 0 && node.is_ok === 0) {
          xCount++;
        }

        if (node.sub_items?.length) {
          node.sub_items.forEach(traverse);
        }
      };

      traverse(item);
      return xCount;
    }
  }
};
</script>

<style scoped>
/* TREE */
.tree-children {
  margin-left: 12px;
  position: relative;
}

.tree-children.root {
  margin-left: 0;
}

.tree-children::before {
  content: "";
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  border-left: 2px dashed #a6a6a6;
}

.card-body.tree-children::before {
  display: none;
}

.tree-item {
  position: relative;
  padding-left: 12px;
  margin-bottom: 12px;
}

.tree-item::before {
  content: "";
  position: absolute;
  top: 14px;
  left: 0;
  width: 12px;
  border-top: 2px dashed #a6a6a6;
}

.tree-item.no-connector::before {
  display: none;
}

/* Remove dangling vertical line */
.tree-node {
  position: relative;
}

.tree-children > .tree-node:last-child::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: calc(100% - 14px);
  width: 2px;
  background: #e5e7eb;
}

/* GROUP */
.category-group {
  margin-bottom: 14px;
}

/* Attach table to card */
.category-card {
  margin-bottom: 0;
  border-radius: 10px 10px 0 0;
  border: 1px solid #a1a1a1;
  border-bottom: none;
}

/* Table extension */
.items-container {
  border: 1px solid #a1a1a1;
  border-top: none;
  border-radius: 0 0 0.75rem 0.75rem;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

.items-container table {
  border-top: none;
  border-radius: 0 0 0.75rem 0.75rem;
}

/* Table polish */
.table {
  margin-bottom: 0;
  border-radius: 0 0 0.75rem 0.75rem;
}

.table td,
.table th {
  vertical-align: middle;
}

.table th{
  text-align: center;
  background: #e9ecef;
}

.button-status{
    min-width: 35px;
    padding:3px 6px;
    border:1px solid #d1d5db;
    border-radius:8px;
    background:#fff;
    text-align:center;
    font-size:12px;
    font-weight:700;
    cursor:pointer;
    transition:.2s;
}

.button-status:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.button-status-ok{
  background:#dcfce7;
  border-color:#22c55e;
  color:#166534;
}

.button-status-not{
  background:#ffffff;
  border-color:#adb5bd;
  color: #42474a;
}

.button-status-x{
  background:#fee2e2;
  border-color:#ef4444;
  color:#b91c1c;
}

.button-status-ncr-type{
  background:#feb272;
  border-color:#fd9843;
  color:#984c0c;
}

.button-status-ncr-not{
  background:#ced4da;
  border-color:#adb5bd;
  color:#6c757d;
}

.button-status-disabled {
  cursor: not-allowed !important;

  /* softer muted look */
  opacity: 0.5;

  /* neutralize colors */
  background: #e5e7eb !important;
  border-color: #d1d5db !important;
  color: #6b7280 !important;

  /* remove effects */
  box-shadow: none !important;
  transform: none !important;
}

.rating-box {
  font-size: 9pt;
  font-weight: 700;
}

.rating-box strong {
  font-size: 9pt;
  margin-left: 1px;
  margin-right: 5px;
}

.main-category{
  border:1px solid #e5e7eb;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-radius: 12px;
  background: #d3313c;
}

.main-category-header{
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom: none;
  background: #d3313c;
  color: #f3f3f3;
  font-weight: 700;
  font-size: 14px;
}

.main-category-body{
  background: #e5e7eb;
  border-radius: 12px;
}

.main-category-footer{
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
  border-top: none;
  background: #d3313c;
}

.summary-label{
  font-size:13px;
  color:#fee2e2;
  font-weight:600;
}

.summary-value{
  padding:6px 9px;
  border-radius:999px;
  font-size:13px;
  font-weight:700;
}

.summary-value.ncr-count{
  background:#fee2e2;
  color:#b91c1c;
}

/* TEXT DIVIDER */
.divider-text {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 1px 0;
}

.divider-text::before,
.divider-text::after {
  content: '';
  flex: 1;
  border-bottom: 3px dashed #cccccc;
}

.divider-text span {
  padding: 0 12px;
  font-size: 9pt;
  font-style: italic;
  color: #6b7280;
  white-space: nowrap;
}

.answer-cell {
  position: relative;
}

.answer-overlay {
  position: absolute;
  inset: 0;
  background: #343a40;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  z-index: 50;
  pointer-events: all;
  user-select: none;
}
</style>
